module.exports = __webpack_public_path__ + "img/logo_2.e1d94e35.png";